import React, { memo } from 'react'
import { PrismicRichText } from '@prismicio/react'
import { Link } from 'gatsby'
import { linkResolver } from '../utils/linkResolver'

const RichText = ({ field, className = '' }) => (
  <div className={className}>
    <PrismicRichText
      field={field}
      linkResolver={linkResolver}
      internalLinkComponent={({ href, ...props }) => (
        <Link to={href} {...props} />
      )}
    />
  </div>
)

export default memo(RichText)
